import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SignUp from '../views/SignUp.vue'
import ShowResults from '../views/ShowResults.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/SignUp',
    name: 'Sign Up',
    component: SignUp
  },
  {
    path: '/e287b37a-7f07-4153-becd-27133e6d3c4c',
    name: 'Show Results',
    component: ShowResults
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
